import { ApolloError, OperationVariables, QueryResult } from '@apollo/client';

export function responseHasError(error: ApolloError | boolean | undefined) {
  return Boolean(error);
}

export type GraphQLResult =
  | QueryResult<any, OperationVariables>
  | {
      hasError?: boolean;
      error?: boolean;
      data?: unknown;
    };

export async function rejectGraphqlError(response: Promise<Partial<GraphQLResult>>) {
  const graphqlReponse = await response;
  return new Promise((res, rej) => {
    if ('hasError' in graphqlReponse) {
      if (responseHasError(graphqlReponse.hasError)) {
        rej(graphqlReponse.data);
      }
    }
    if ('error' in graphqlReponse) {
      if (responseHasError(graphqlReponse.error)) {
        rej(graphqlReponse.error);
      }
    }
    res(graphqlReponse);
  });
}
